import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import noAvatar from '../../assets/img/icons/avatar.svg';

const readableNumber = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export default class RankingRow extends Component {
  static propTypes = {
    rank: PropTypes.number,
    title: PropTypes.string,
    color: PropTypes.string,
    avatar: PropTypes.string,
    className: PropTypes.string,
    points: PropTypes.number,
    to: PropTypes.string,
    schoolClass: PropTypes.bool,
    showSchoolClassName: PropTypes.bool,
  };
  static defaultProps = {
    rank: 1,
    title: '-',
    color: 'red',
    avatar: '',
    className: '-',
    points: 0,
    to: '',
    showSchoolClassName: true,
  };

  render() {
    return (
      <div className={`ranking-row ${this.props.color}`}>
        <div className={`ranking-row-inner ${this.props.color}`}>
          <div className={'badge'}>
            <span className={`badge-border border-${this.props.color}`} />
            <div className={'rank-badge'}>{this.props.rank}</div>
          </div>
          <div className={'title'}>
            {this.props.to.length
              ? (
                <Link href={this.props.to} to={this.props.to}>{this.props.title}</Link>
              )
              : this.props.title
            }
          </div>
          <div className={'avatar'}>
            <img src={(this.props.avatar.length)
              ? this.props.avatar
              : noAvatar} alt={'avatar'} />
          </div>
          {this.props.showSchoolClassName ? <div className={'className'}>{this.props.className}</div> : null}
          <div className={'points'}>{readableNumber(this.props.points)}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/RankingRow.js